import { useMemo } from 'react';
import { useQuery } from '@supabase-cache-helpers/postgrest-swr';

import { supabase } from 'src/auth/context/supabase/lib';

// ----------------------------------------------------------------------

const defaultColumns =
  'id,created_at,name,is_goal,goal_value,workstation,inventory_id,co2eq_per_employee,workstation_percent,number_of_employees_equipped, goal_value';

export function useGetAllSimulationFromEntity(entity_id) {
  const { data, isLoading, error, isValidating } = useQuery(
    supabase.from('simulations').select(defaultColumns).eq('entity_id', entity_id)
  );

  const memoizedValue = useMemo(
    () => ({
      simulations: data || [],
      simulationsLoading: isLoading,
      simulationsError: error,
      simulationsValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetBySimulationId(simulation_id, columns = defaultColumns) {
  const { data, isLoading, error, isValidating } = useQuery(
    !simulation_id ? null : supabase.from('simulations').select(columns).eq('id', simulation_id)
  );

  const memoizedValue = useMemo(
    () => ({
      simulations: data || [],
      simulationsLoading: isLoading,
      simulationsError: error,
      simulationsValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetSimulationGoalFromEntity(entity_id) {
  const { data, isLoading, error, isValidating } = useQuery(
    supabase
      .from('simulations')
      .select(defaultColumns)
      .eq('entity_id', entity_id)
      .eq('is_goal', true)
  );

  const memoizedValue = useMemo(
    () => ({
      simulations: data || [],
      simulationsLoading: isLoading,
      simulationsError: error,
      simulationsValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
